import { YearRow } from '../../../models/analytics/analytics.model';
import { useGet } from '../../useApi';

// GET /admin/analytics/years
const useYearsAnalytics = () => {
  const { data, loading, fetch } = useGet<{ years: YearRow[] }>('Failed to load yearly growth');
  return { years: data?.years ?? [], loading, fetchYears: () => fetch('api/v1/admin/analytics/years') };
};

export default useYearsAnalytics;
